import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { UsersService } from 'src/app/service/users/users.service';
import { AlertService } from 'src/app/service/shared/alert/alert.service';
import { ToastService } from 'src/app/service/shared/toast/toast.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  innerHeight;
  token;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private userService: UsersService,
    private toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.innerHeight = window.innerHeight + 'px';
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
    });
    this.createForm();
  }

  createForm() {
    this.resetPasswordForm = this.formBuilder.group(
      {
        password: ['', [Validators.required]],
        confirm_password: ['', [Validators.required]],
        token: [this.token],
        is_reset: [1],
      },
      {
        validator: this.confirmedValidator('password', 'confirm_password'),
      },
    );
  }

  onSubmit(form) {
    if (form.invalid) {
      Object.keys(form.controls).forEach(field => {
        // {1}
        const control = form.get(field); // {2}
        control.markAsTouched({ onlySelf: true }); // {3}
      });
    } else {
      this.userService.resetUserPassword(form.value).subscribe(
        res => this.onSuccess(res),
        err => this.onError(err),
      );
    }
  }

  onSuccess(result) {
    if (result) {
      if (result.data.message) {
        this.toastService.showToast(result.data.message, 'success');
        this.router.navigateByUrl('/');
      }
    }
  }

  onError(result) {
    if (result.errors) {
      this.alertService.showAlert(result.errors.message, 'error_with_sign');
    }
  }

  confirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }
}
